import { useHostname } from '@bv/composables/common/hostname';
import { useBrandStore } from '@bv/stores/brand';

import { normalizeUrlPath } from '../normalize-path';

/**
 * Returns the console URL for the given path
 *
 * @param path - The path to get the console URL for
 *
 * @returns The console URL
 * @example
 * ```ts
 * const rootUrl = getConsoleUrl();
 * console.log(rootUrl); // https://app.bevatel.com
 *
 * const dashboardUrl = getConsoleUrl('dashboard');
 * console.log(dashboardUrl); // https://app.bevatel.com/dashboard
 * ```
 */
export const getConsoleUrl = (path?: string): string => {
  const { domain } = useHostname();

  const consoleSubdomain: string | undefined = useBrandStore().config?.subdomains.console;

  const normalizedPath = normalizeUrlPath(path);

  return `https://${consoleSubdomain}.${domain}${normalizedPath}`;
};
